export const getMagnitude = (value) => {
  return Math.ceil(Math.log10(Math.abs(value) + 1)) - 1;
};

export const getUnitIndexFromMagnitude = (magnitude) => {
  if (isNaN(magnitude)) {
    return 0;
  } else if (magnitude < 3) {
    return 0;
  } else if (magnitude < 6) {
    return 1;
  } else if (magnitude < 9) {
    return 2;
  } else if (magnitude < 12) {
    return 3;
  } else {
    return 4;
  }
};

export const getUnitDivisorFromMagnitude = (magnitude) => {
  if (magnitude < 3) {
    return 1;
  } else if (magnitude < 6) {
    return 1e3;
  } else if (magnitude < 9) {
    return 1e6;
  } else if (magnitude < 12) {
    return 1e9;
  } else {
    return 1e12;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/utilities/UnitsAndKeys/fromMagnitude.js